import {useEffect, useContext} from 'react';
import { useTranslation } from 'react-i18next';
import Servers from './Servers';
import './servers.css'
import { observer } from 'mobx-react-lite';
import { Context } from '../../../index';
import LoaderMonitoring from '../../Loaders/LoaderMonitoring';

function Groups({extendedInfo,servers}:any) {
    return (
        <div className="monitoring__group">
            {servers.map((servers:any, index:number) => (
                <div className='monitoring__servergroup' key={`monitoring__servergroup-${index}`}>
                    <div className={extendedInfo ? "monitoring__servergroup_title extended":"monitoring__servergroup_title"}>{servers[0].serviceData.group}</div>
                    <div className="monitoring__servers">
                        {servers?.map((server:any, i:number) => (
                            <Servers
                                key={server?.id + '_' + i}
                                srv={server}
                                extendedInfo={extendedInfo}
                            />
                        ))}
                    </div>
                </div>
            ))}
        </div>
    )
}

function Monitoring({titleEnabled, extendedInfo}:any) {
    const {store} = useContext(Context)
    const { t } = useTranslation();
    useEffect(() => {
        store.serversInfo();
        const intervalMonitor = setInterval(() => store.serversInfo(), 15e3);
        return () => clearInterval(intervalMonitor)
    }, [])
    if (store.isServersLoaded) {
        return (
            <div className={titleEnabled ? 'monitoring_table': 'xbox__div-1 monitoring_table'}>
                {titleEnabled && <h1 className="global__title monitoring__title">{t('main.monitoring.title')}</h1>}
                <div className="monitoring__body">
                    <Groups
                        extendedInfo = {extendedInfo}
                        servers = {store.servers}
                    />
                </div>
            </div>
        )
    } else {
        return (
            <div className={titleEnabled ? 'monitoring_table': 'xbox__div-1 monitoring_table'}>
                {titleEnabled && <h1 className="global__title monitoring__title">{t('main.monitoring.title')}</h1>}
                <div className="monitoring__body">
                    <LoaderMonitoring />
                </div>
            </div>
    )}
}

export default observer(Monitoring);